<template>
  <main class="grid grid-cols-12 gap-6 md:grid-flow-col grid-flow-row">
    <section
      class="col-span-12 md:col-span-8 rounded-lg flex flex-col order-2 md:order-first"
      style="
        gap: 1px;
        filter: drop-shadow(0px 15px 20px rgba(157, 163, 180, 0.16));
      "
    >
      <NotificationItemCard v-if="!activeAlex" />
      <div v-else>
        <div class="pt-3">
          <h3 class="text-xl strong notification__text pb-4 pt-2">
            <span class="cursor-pointer" @click="activeAlex = false"
              >&larr; Back
            </span>
          </h3>
        </div>
        <AlexView :itemData="itemData" />
      </div>
    </section>

    <section class="col-span-12 md:col-span-4 relative flex">
      <div
        class="sticky flex lg:mt-16 w-full mt-0"
        style="
          height: fit-content;
          top: 6rem;
          filter: drop-shadow(0px 15px 20px rgba(157, 163, 180, 0.16));
        "
      >
        <profile-card class="w-100" />
      </div>
    </section>
  </main>
</template>

<script>
import NotificationItemCard from "./components/NotificationItemCard.vue";
import ProfileCard from "../components/ProfileCard.vue";
import AlexView from "../../quiz/Main.vue";

export default {
  data() {
    return {
      activeAlex: false,
      itemData: [],
    };
  },
  components: {
    NotificationItemCard,
    ProfileCard,
    AlexView,
  },
};
</script>

<style scoped></style>
